module.exports = __webpack_public_path__ + "img/icon-eye.413b7191.svg";